module.exports = __webpack_public_path__ + "static/media/ic_launcher.c359a27f.png";